import styled from '@emotion/styled';

export const Header = styled.div(
  ({ theme }) => `
  padding: ${theme.spacing(4)};
  background: ${theme.palette.bg.default};
  ${theme.media.up('md')} {
    padding: ${theme.spacing(5, 10)};
  }
  ${theme.media.down('sm')} {
    height: 78px;
  }
`,
);
